import Api from './Api';

export default class Gestores {
  public static async get(request?: IRequestOptions): Promise<GetGestoresResponse> {
    const response = await Api.instance.get<GetGestoresResponse>('/gestores', {
      params: request?.params,
    });
    return response.data;
  }
}
